import { css } from "@emotion/react";
import { theme } from "@xometry/xometry_loft";

export const CloseButtonContainer = css`
  color: ${theme.colors.darkBlues[50]};
  font-size: ${theme.fontSizes[4]};
  line-height: ${theme.lineHeights[6]};
  position: absolute;
  right: ${theme.space[6]};
  top: ${theme.space[6]};

  i {
    cursor: pointer;
  }
`;

export const LineItemFormContainer = css`
  legend {
    margin-bottom: ${theme.space[5]};
    padding-bottom: ${theme.space[5]};

    border-bottom: 1px solid ${theme.colors.darkBlues[10]};
    box-sizing: border-box;
    width: 100%;
  }
`;
